import { jsx, jsxs } from "react/jsx-runtime";
import { Fragment } from "react";
import Menu from "@crehana/icons/outline/Menu";
import { useIsClient } from "@crehana/react-hooks";
import classnames from "classnames";
import { useMainMenuContext, useMainMenuTranslation } from "../../../../hooks/index.js";
import LeftMenuDrawer from "./LeftMenuDrawer/index.js";
const LeftMenuMobile = ({ className, ...leftMenuMobileProps })=>{
    const { theme, onLeftMenuOpen } = useMainMenuContext();
    const isClient = useIsClient();
    const { t } = useMainMenuTranslation();
    return /*#__PURE__*/ jsxs(Fragment, {
        children: [
            /*#__PURE__*/ jsx("button", {
                type: "button",
                "aria-label": t('OPEN_MENU'),
                name: t('LEFT_MENU_TITLE'),
                onClick: isClient ? onLeftMenuOpen : void 0,
                className: classnames('left-menu-mobile w-24 h-32 flex items-center justify-center flex-shrink-0 mr-12 sm:mr-40', theme.nav.iconColorClassName, className),
                children: /*#__PURE__*/ jsx(Menu, {
                    size: 24,
                    "aria-hidden": true,
                    ignoreColor: true,
                    className: "fill-current"
                })
            }),
            /*#__PURE__*/ jsx(LeftMenuDrawer, {
                ...leftMenuMobileProps
            })
        ]
    });
};
const LeftMenuMobile_LeftMenuMobile = LeftMenuMobile;
export default LeftMenuMobile_LeftMenuMobile;
